import { NavLink } from "react-router-dom";
import { type Navtab } from "../schema";

export interface NavDropDownProps {
  navItem: Navtab;
  onClose: () => void;
  isMobileMenuOpen: boolean;
  activeDropdown: string | null;
}

const NavDropdown = ({ navItem, onClose, isMobileMenuOpen, activeDropdown }: NavDropDownProps) => {
  return (
    <>
      {/* Desktop Dropdown*/}
      {navItem.sublinks && (
        <ul
          className={`hidden md:flex flex-col md:absolute top-full transition-all duration-300 ease-in-out bg-black pt-5 pb-2 px-5 list-none w-full md:w-[130px] 3xl:w-[145px] ${
            activeDropdown === navItem.to && !isMobileMenuOpen
              ? "opacity-100 visible"
              : "opacity-0 invisible"
          }`}
        >
          {navItem.sublinks.map((link) => (
            <li key={link.href + link.hash}>
              <NavLink
                to={`${link.href}${link.hash}`}
                onClick={onClose}
                className={({ isActive }) =>
                  `block py-2 text-sm 3xl:text-base duration-100 ease-in-out font-[GTFlexa-ExtendedLightItalic] ${
                    isActive ? "text-cultiv-yellow" : "text-white hover:text-cultiv-yellow"
                  }`
                }
              >
                {link.label}
              </NavLink>
            </li>
          ))}
        </ul>
      )}

      {/* Mobile Dropdown*/}
      {navItem.sublinks && activeDropdown === navItem.to && isMobileMenuOpen && (
        <ul className="md:hidden bg-black pt-1 pb-3 px-5 list-none w-full">
          {navItem.sublinks.map((link) => (
            <li key={link.href + link.hash}>
              <NavLink
                to={`${link.href}${link.hash}`}
                onClick={onClose}
                className={({ isActive }) =>
                  `animate-dropdown-nav-slide-down block py-2 text-sm 3xl:text-base duration-100 ease-in-out font-[GTFlexa-ExtendedLightItalic] ${
                    isActive ? "text-cultiv-yellow" : "text-white"
                  }`
                }
              >
                {link.label}
              </NavLink>
            </li>
          ))}
        </ul>
      )}
    </>
  );
};

export default NavDropdown;
